export default __webpack_public_path__ + "static/media/c9c1472a3e0767b61004b4c2b99a2175.png";